export default class ScriptData {
    constructor(data) {
        var _a, _b, _c, _d;
        Object.defineProperty(this, "googleTroas", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pmax", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "retargeting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (data === null || data === void 0 ? void 0 : data.success) {
            this.retargeting = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.retargeting;
            this.googleTroas = (_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.metasearchAds) === null || _c === void 0 ? void 0 : _c.googleTroas;
            this.pmax = (_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.pmax;
        }
    }
}
